exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".price-input[data-v-3216f63e]{min-width:200px;width:100%}", ""]);

// exports
